var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wifi-off",
    clipPath: "url(#clip0_3256_26151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.7616 8.33335C13.9018 8.68861 14.9703 9.26592 15.9016 10.0417M18.8182 7.08331C16.3829 4.93662 13.248 3.75219 10.0016 3.75219C9.49739 3.75219 8.9959 3.78075 8.49931 3.83706M7.10978 13.0084C7.95578 12.4073 8.96784 12.0844 10.0056 12.0844C11.0434 12.0844 12.0554 12.4073 12.9014 13.0084M10.0016 16.25H10.01M0.996094 7.25063C2.10743 6.23224 3.39195 5.39979 4.80038 4.80255M3.94491 10.2025C5.10941 9.17665 6.5364 8.4418 8.11216 8.11161M13.0836 13.1459C12.2343 12.4802 11.1643 12.0833 10.0015 12.0833C8.8212 12.0833 7.7364 12.4923 6.8811 13.1763M2.50163 2.5L17.5016 17.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3256_26151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiOff);
export default __webpack_public_path__ + "static/media/wifi-off.2c70c849c0ffe0d15d71d5b1f38fc7af.svg";
export { ForwardRef as ReactComponent };